import React from 'react';

import { Flex } from 'Components/Base';
import { ClearLoadingIcon } from 'Components/Classroom/Clear/ClearAttachment/AttachmentItem';

export default function SolutionLoading() {
  return (
    <Flex flex={1} height={'calc(100% - 200px)'} alignItems={'center'} justifyContent={'center'}>
      <ClearLoadingIcon />
    </Flex>
  );
}
